<div class="searcher-container">
    <div class="search-input-wrapper">
        <img src="/assets/icons/searchIcon.svg" alt="Search" class="search-icon">
        <input #searchInput type="text" [formControl]="searchControl" [placeholder]="placeholder" [required]="required"
            (focus)="onFocus()" (blur)="onBlur()" (click)="onInputClick()" class="search-input"
            [ngClass]="{'input-error': shouldShowError}" />

        <div class="loading-indicator" *ngIf="isLoading">
            <div class="spinner"></div>
        </div>

        <button *ngIf="searchControl.value && !isLoading" type="button" class="clear-button" (click)="clearSearch()"
            [attr.aria-label]="'Limpiar búsqueda'">
            ×
        </button>
    </div>
    <div #resultsContainer class="search-results" (mousedown)="$event.preventDefault()"
        *ngIf="showResults || (hasSearched && searchControl.value && searchControl.value.length >= minChars && results.length === 0)">
        <div *ngIf="hasSearched && results.length === 0 && searchControl.value && searchControl.value.length >= minChars"
            class="no-results">
            {{ 'common.noAvailable' | translate }}
        </div>

        <p *ngIf="showWarningMessage" class="warning-message">
            {{ 'common.warningMessage' | translate }}
        </p>
        <ul *ngIf="results.length > 0">
            <ng-container *ngIf="groupByField && groupedResults.length > 0; else flatList">
                <ng-container *ngFor="let group of groupedResults">
                    <li class="group-header" *ngIf="group.label" (mousedown)="onGroupMousedown($event, group)">
                        <span class="group-header-text">{{ group.label }}</span>
                        <span class="group-header-hint">+</span>
                    </li>
                    <li *ngFor="let item of group.items" (mousedown)="onItemMousedown($event, item)"
                        [class.selected]="isItemSelected(item)" class="group-item">
                        {{ getDisplayValue(item) }}
                    </li>
                </ng-container>
            </ng-container>

            <ng-template #flatList>
                <li *ngFor="let item of results" (mousedown)="onItemMousedown($event, item)"
                    [class.selected]="isItemSelected(item)">
                    {{ getDisplayValue(item) }}
                </li>
            </ng-template>
        </ul>
    </div>
</div>